import React, { Fragment } from "react";
import _ from "lodash";
import { Table, Button } from "react-bootstrap";
import Input from "../../elements/CustomInput";
import Select from "../../elements/CustomSelect";

// Presentational list for un-synced CubiCasa orders. All filtering and
// pagination state lives in the container; this component only renders.
const CubiCasaOrdersList = ({
  rows,
  filters,
  createdByOptions,
  createdAtOptions,
  handleFilterChange,
  handleReset,
  pagination,
  handlePageChange,
  onRowClick,
}) => {
  const { from, to, total, totalPages, page } = pagination;

  return (
    <Fragment>
      <div className="d-flex align-items-end justify-content-between mb-3 gap-2 flex-wrap">
        <div style={{ minWidth: "220px", flex: "1 1 220px" }}>
          <Input
            label="Property Address"
            ids="propertyAddress"
            value={filters.propertyAddress}
            validate={false}
            handleChange={handleFilterChange}
          />
        </div>
        {/*<div style={{ minWidth: "180px", flex: "1 1 180px" }}>
          <Select
            label="Created At"
            result={createdAtOptions}
            ids="createdAt"
            value={filters.createdAt}
            handleChange={handleFilterChange}
            validate={false}
          />
        </div>*/}
        <div style={{ minWidth: "180px", flex: "1 1 180px" }}>
          <Select
            label="Created By"
            result={createdByOptions}
            ids="createdBy"
            value={filters.createdBy}
            handleChange={handleFilterChange}
            validate={false}
          />
        </div>
        <Button variant="outline-secondary" onClick={handleReset}>
          Reset
        </Button>
      </div>

      <Table bordered responsive hover>
        <thead>
          <tr>
            <th>Property Address</th>
            <th>Created At</th>
            <th>Ready At</th>
            <th>Created By</th>
          </tr>
        </thead>
        <tbody>
          {!_.isEmpty(rows) ? (
            _.map(rows, (row) => (
              <tr
                key={row.logId}
                onClick={() => onRowClick(row)}
                style={{ cursor: "pointer" }}
              >
                <td>{row.propertyAddress}</td>
                <td>{row.createdAtDisplay}</td>
                <td>{row.readyAtDisplay}</td>
                <td>{row.createdBy}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" className="text-center">
                No Data Found
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      <div className="d-flex align-items-center justify-content-between flex-wrap">
        <span className="text-muted">
          Showing {from} to {to} of {total} results
        </span>
        {totalPages > 1 && (
          <div className="d-flex gap-1">
            <Button
              size="sm"
              variant="outline-secondary"
              disabled={page <= 1}
              onClick={() => handlePageChange(page - 1)}
            >
              Prev
            </Button>
            {_.range(1, totalPages + 1).map((p) => (
              <Button
                key={p}
                size="sm"
                variant={p === page ? "primary" : "outline-secondary"}
                onClick={() => handlePageChange(p)}
              >
                {p}
              </Button>
            ))}
            <Button
              size="sm"
              variant="outline-secondary"
              disabled={page >= totalPages}
              onClick={() => handlePageChange(page + 1)}
            >
              Next
            </Button>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default CubiCasaOrdersList;
